




























import { getProjectDefaultProfitRate } from "@/api/project-default-profit-rate-api";
import Decimal from "decimal.js";
import { Component, Prop, Vue } from "vue-property-decorator";

@Component({
  model: {
    prop: "open",
    event: "change"
  }
})
export default class ProfitRateModal extends Vue {
  @Prop({ type: String, default: "自動入力" }) title!: string;
  @Prop({ type: Boolean, required: true }) open!: boolean;
  @Prop({ type: String, required: true }) projectId!: string;
  @Prop() templateProfitRate!: { profitRate: string; lossRate: string };

  profitRate = 0;

  get profitRatePercent(): string {
    return new Decimal(this.profitRate).mul(100).toString();
  }

  set profitRatePercent(profitRatePercent: string) {
    if (!profitRatePercent) {
      this.profitRate = 0;
      return;
    }
    this.profitRate = new Decimal(profitRatePercent).div(100).toNumber();
  }

  get lossRatePercent(): string {
    return new Decimal(100).minus(this.profitRatePercent).toString();
  }

  show() {
    this.initProfitRate();
  }

  ok() {
    (this.$refs["btnSave"] as HTMLButtonElement).click();
  }

  hide() {
    this.$emit("change", false);
  }

  submit() {
    this.$emit("ok", this.profitRate);
  }

  async initProfitRate() {
    if (this.projectId != "") {
      const project = await getProjectDefaultProfitRate(this.projectId);
      this.profitRate = project.profitRate;
    } else {
      this.profitRate = Number(this.templateProfitRate.profitRate);
    }
  }
}
